/**
 * API endpoint paths
 * Base URL comes from environment configuration
 */
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    SIGN_IN: '/auth/login', // Backend uses /auth/login
    SIGN_UP: '/auth/signup',
    SIGN_OUT: '/auth/signout',
    REFRESH_TOKEN: '/auth/refresh',
    CURRENT_USER: '/auth/current-user', // Fetch user data with JWT
    VERIFY_EMAIL: '/auth/verify-email',
    RESET_PASSWORD_REQUEST: '/auth/reset-password-request',
    RESET_PASSWORD_CONFIRM: '/auth/reset-password-confirm',
    GOOGLE_AUTH: '/auth/google',
    PERMISSIONS: (id: string) => `/auth/permissions/${id}`,
  },
  
  // User management
  USERS: {
    BASE: '/users',
    PROFILE: '/users/profile',
    UPDATE: '/users/profile',
    CHANGE_PASSWORD: '/users/change-password',
  },
  
  // Transactions
  TRANSACTIONS: {
    BASE: '/transactions',
    SEARCH: '/transactions/search',
    EXPORT: '/transactions/export',
    DETAILS: (id: string) => `/transactions/${id}`,
  },
  
  // Customers
  CUSTOMERS: {
    BASE: '/customers',
    SEARCH: '/customers/search',
    DETAILS: (id: string) => `/customers/${id}`,
  },
  
  // Invoices
  INVOICES: {
    BASE: '/invoices',
    CREATE: '/invoices',
    DETAILS: (id: string) => `/invoices/${id}`,
    SEND: (id: string) => `/invoices/${id}/send`,
  },
  
  // Disputes
  DISPUTES: {
    BASE: '/disputes',
    DETAILS: (id: string) => `/disputes/${id}`,
    RESPOND: (id: string) => `/disputes/${id}/respond`,
  },
  
  // Balances
  BALANCES: {
    BASE: '/balances',
    HISTORY: '/balances/history',
    PAYOUT: '/balances/payout',
  },
  
  // Analytics
  ANALYTICS: {
    OVERVIEW: '/analytics/overview',
    REVENUE: '/analytics/revenue',
    TRANSACTIONS: '/analytics/transactions',
  },
  
  // Reports
  REPORTS: {
    AFFISE_ADVERTISERS: '/exchange/api/v1/affise/advertisers',
    AFFISE_OFFERS: '/exchange/api/v1/affise/offers',
    AFFISE_AFFILIATES: '/exchange/api/v1/affise/affiliates',
    AFFISE_REPORT: '/exchange/api/v1/affise/report',
    ADWORA_REPORT: '/exchange/api/v1/adwora/report',
    FACEBOOK_REPORT: '/exchange/api/v1/facebook/report',
  },
} as const;

/**
 * HTTP status codes for reference
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

/**
 * HTTP headers
 */
export const HTTP_HEADERS = {
  AUTHORIZATION: 'Authorization',
  CONTENT_TYPE: 'Content-Type',
  ACCEPT: 'Accept',
  X_REQUEST_ID: 'X-Request-ID',
  X_API_KEY: 'X-API-Key',
} as const;


